import React, {Component} from 'react'
import GA from 'react-ga'
import ym, {YMInitializer} from 'react-yandex-metrika';

GA.initialize('UA-133769240-1')

const GoogleAnalytics = (WrappedComponent, options = {}) => {
  const trackPage = page => {
    GA.set({
      page,
      ...options,
    });
    GA.pageview(page);
    ym('hit', page);
  };

  const HOC = class extends Component {
    componentDidMount() {
      const page = this.props.location.pathname;
      trackPage(page);
    }

    componentWillReceiveProps(nextProps) {
      const currentPage = this.props.location.pathname;
      const nextPage = nextProps.location.pathname;

      if (currentPage !== nextPage) {
        trackPage(nextPage);
      }
    }

    render() {
      return <YMInitializer accounts={[52217332]} options={{webvisor: true}}
                            version="2"><WrappedComponent {...this.props} /></YMInitializer>
    }
  };

  return HOC;
};

export default GoogleAnalytics


// WEBPACK FOOTER //
// ./src/Analytics.js